import { RecordContextProvider } from 'react-admin';
import { Box } from 'shared/mui/Box';
import { CardHeader } from 'shared/mui/Card/CardHeader/CardHeader';
import { Dialog, DialogProps } from 'shared/mui/Dialogs';
import { CloseIconButton } from 'shared/mui/IconButtons';
import { MethodLogo } from 'types/embedded/methodLogo';

import { StyledBox } from './MethodLogosShowDialog.styled';
import { MethodLogosShowDialogTable } from './MethodLogosShowDialogTable';

type MethodLogosShowDialogTableProps = {
  methodLogo?: MethodLogo;
  onClose: () => void;
  sourceId?: string;
} & DialogProps;

export const MethodLogosShowDialog = ({
  open,
  methodLogo,
  onClose,
  sourceId = 'originId',
}: MethodLogosShowDialogTableProps): JSX.Element => (
  <Dialog maxWidth="md" onClose={onClose} open={open}>
    <StyledBox>
      <CardHeader
        appendActions={[<CloseIconButton key="close-button" onClose={onClose} />]}
        title="Просмотр логотипа"
        titleSize="smallBold"
      />
      <Box p={3}>
        <RecordContextProvider value={methodLogo}>
          <MethodLogosShowDialogTable sourceId={sourceId} />
        </RecordContextProvider>
      </Box>
    </StyledBox>
  </Dialog>
);
